//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Logout = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Logout"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_3591)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.64784 12.5565C6.20289 12.1127 6.20226 11.394 6.64784 10.9496L8.45652 9.14655H1.13877C0.509688 9.14655 0 8.63844 0 8.01096C0 7.38348 0.510315 6.87475 1.13877 6.87475L8.47728 6.87475L6.64784 5.05115C6.20289 4.6074 6.20226 3.88806 6.64784 3.44433C7.09221 3.00123 7.81369 3.0006 8.25863 3.44433L12.2908 7.46417C12.5874 7.7604 12.588 8.24038 12.2908 8.53662L8.25863 12.5565C7.81364 13.0002 7.09279 13.0002 6.64784 12.5565ZM13.8544 1.06684L13.8544 14.9332C13.8544 15.5225 14.3346 16 14.9272 16C15.4073 16 16 15.5225 16 14.9332L16 1.06684C16 0.477485 15.5198 0 14.9272 0C14.447 0 13.8544 0.477485 13.8544 1.06684Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21705_3591">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
